import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { to: '/', label: '首页' },
    { to: '/about', label: '关于我们' },
    { to: '/category/ecommerce', label: '电商优惠' },
    { to: '/category/membership', label: '会员权益' },
  ];

  const friendLinks = [
    { to: '/category/subsidy', label: '生活补贴' },
    { to: '/category/career', label: '职场福利' },
    { to: '/category/freebie', label: '免费福利' },
    { to: '/category/finance', label: '金融福利' },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-gift-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-heading text-foreground-900">福利导航</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              福利导航为您汇聚全网优质福利资源，涵盖电商优惠、会员权益、生活补贴、职场福利等多类目，帮助用户快速找到最划算的福利入口。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">
              <a href="/category/ecommerce" className="hover:text-primary-500 transition-colors">快速入口</a>
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">
              <a href="/category/subsidy" className="hover:text-primary-500 transition-colors">福利分类</a>
            </h4>
            <ul className="space-y-2.5">
              {friendLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground-900 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </span>
                <span>contact@fulidaohang.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-wechat-line text-sm"></i>
                </span>
                <span>福利导航官方公众号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 福利导航 fulidaohang.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="/about" className="hover:text-primary-500 transition-colors">关于我们</a>
            <a href="/about" className="hover:text-primary-500 transition-colors">联系方式</a>
          </div>
        </div>
      </div>
    </footer>
  );
}